import React from "react";
import SectionTitle from "../../elements/section-title/SectionTitle";
import CounterUp from "../../component/counterup/CounterUp";
import SectionTitle1 from "../../elements/section-title/SectionTitle1";

const CounterUpOne = () => {
  return (
    <div className="section section-padding bg-color-dark">
      <div className="container">
        <SectionTitle1
          subtitle="Featured Case Study"
          title="Facilities Management Company"
          description="Providing reliable and efficient facilities management solutions for your business success."
          textAlignment="heading-light"
          textColor=""
        />
        <div className="row">
          <CounterUp colSize="col-lg-3 col-6" layoutStyle="" evenTopMargin="" />
        </div>
      </div>
    </div>
  );
};

export default CounterUpOne;
